import type { ViewType } from '@taki/ui';
import { calendrier, fiche, kanban, liste, tableau } from '@taki/ui/views/core';

/**
 * LE CATALOGUE DE VUES de l'ecran Reservations, partage entre l'ecran et le
 * module de reglages : un seul endroit, sinon la liste deroulante des
 * Parametres et le selecteur de la zone 4 finissent par diverger.
 *
 * Les vues sont importees EXPLICITEMENT depuis `@taki/ui/views/core` : une vue
 * ne s'auto-enregistre jamais, sans cet import le build la supprimerait.
 *
 * Ici LES CINQ SONT NOURRIES, et c'est le propos de l'app : une location porte
 * un titre (le projet), un statut, une date de depart, une date de retour, des
 * montants comparables et un champ d'etat qu'on fait avancer a la souris. Aucune
 * entree grisee : c'est l'app vitrine du pack de demonstration.
 */
export const RESERVATIONS_VIEW_TYPES: ViewType[] = [liste, tableau, kanban, calendrier, fiche];

/** Ids passes a `useScreen` et a `ViewDefaultSetting` : ils doivent coincider. */
export const RESERVATIONS_APP_ID = 'reservations';
export const RESERVATIONS_SCREEN_ID = 'locations';
